import React, { useState } from "react";
import { ProtectedImage } from "../Components/ProtectedMedia";
import { Modal } from "antd";
import * as M from "./styled";
import { useSelector } from "react-redux";
import { RootState } from "../Redux/store";
import toast from "react-hot-toast";
import DefaultUserImg from "../Assets/Images/user-profile.png";
import { MdVerified } from "react-icons/md";
import { CommonButton } from "../common-styles";
import {
  ExploreList,
  PaymentSuccessResponse,
} from "../Config/interface.config";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import {
  DEFAULT_PRICING,
  getCheckoutContactNumber,
  loadScript,
} from "../Config/common.config";
import APIRequest from "../API";
import * as APIPath from "../API/path";
import { OrderResponse } from "../Pages/Chat/chat.interface";
import { UserPublicProfile } from "../Pages/Profile/ViewProfile/interface";
import { Link, useNavigate } from "react-router-dom";

interface Props {
  onHide: () => void;
  show: boolean;
  selectedCreator?: ExploreList | null | UserPublicProfile;
  setRefreshFeedsWithCreatorList?: (isUpdate: boolean) => void;
  urlusername?: string;
}

const SubscriptionModal: React.FC<Props> = ({
  onHide,
  show,
  selectedCreator,
  setRefreshFeedsWithCreatorList,
  urlusername,
}) => {
  const { fullname, image, username, membership, memberDetails } =
    selectedCreator ?? {};
  const id = selectedCreator?.id ?? selectedCreator?._id;
  const user = useSelector((state: RootState) => state.user);
  const [selectedPlan, setSelectedPlan] = useState(1);
  const navigate = useNavigate();
  const checkoutContact = getCheckoutContactNumber(user);
  const getPrice = (num: number) => {
    const price: number = parseInt(
      membership?.monthlyPrice
        ? membership?.monthlyPrice
        : memberDetails?.monthlyPrice
        ? memberDetails?.monthlyPrice
        : DEFAULT_PRICING.toString()
    );

    if (num === 1) return price;
    if (num === 3) return price * 3;
    return 0;
  };

  const selectedClassName =
    "bg-gradient-to-b from-[#146BC3] via-[#B77BC6] to-[#F48E1D]";

  const subscripCreatorOnPaymentSuccess = async (
    response: PaymentSuccessResponse
  ) => {
    toast.success("Payment received. Verifying subscription...");
    navigate(
      `/payment-verification?username=${username}&sub_id=${response.razorpay_subscription_id}&creator_id=${id}`
    );
    // toast.loading("Processing subscription, Please wait..");
    // const checkSubscriptionStatus = async (retryCount = 0) => {
    //   if (retryCount >= 5) {
    //     // Max 5 retries
    //     toast.error(
    //       "Subscription activation taking too long, please refresh later."
    //     );
    //     return;
    //   }

    //   const { data, error } = await APIRequest(
    //     APIPath.CheckSubscriptionStatus,
    //     {
    //       subscriptionId: response.razorpay_subscription_id,
    //     }
    //   );

    //   if (error || !data?.isActive) {
    //     setTimeout(() => checkSubscriptionStatus(retryCount + 1), 5000); // Retry after 2 seconds
    //   } else {
    //     // Now subscription is active
    //     const payload = {
    //       creatorId: id,
    //       orderId: response.razorpay_subscription_id,
    //     };
    //     const { type } = await dispatch(subscribeCreator(payload));
    //     toast.remove();
    //     if (type === "subscribe/rejected") {
    //       return toast.error(
    //         "Unexpected error occurred, please try again later"
    //       );
    //     }
    //     await dispatch(
    //       createMessageChannel({
    //         from: user_id!,
    //         to: selectedCreator?.id!,
    //         type: "subscribed",
    //       })
    //     );
    //     toast.success(
    //       `Successfully subscribed to ${selectedCreator?.fullname} account`
    //     );
    //     setRefreshFeedsWithCreatorList && setRefreshFeedsWithCreatorList(true);
    //   }
    // };

    // // Start polling
    // checkSubscriptionStatus();
  };

  const initiatePayment = async ({ data }: OrderResponse) => {
    onHide();
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const paymentObject = new (window as any).Razorpay({
      key: process.env.REACT_APP_RAZORPAY_KEY_ID, // ✅ Razorpay key
      subscription_id: data.subscription.id, // ✅ Use subscription ID now
      name: "Fanxo Premium Membership",
      description: `Subscription to ${selectedCreator?.fullname}`,
      handler: subscripCreatorOnPaymentSuccess, // ✅ Callback on success
      prefill: {
        name: user?.fullname || "Fanxo",
        email: user?.email || "fanxobusiness@gmail.com",
        contact: checkoutContact,
      },
      theme: {
        color: "#001676",
      },
      // callback_url: `https://api.fanxo.club/v1/payment/payment-verification?sub_id=${data.subscription.id}&creator_id=${id}`,
      // redirect: {
      //   success: `https://fanxo.club/payment-verification?sub_id=${data.subscription.id}&creator_id=${id}`,
      //   failure: `https://fanxo.club/payment-verification?sub_id=${data.subscription.id}&creator_id=${id}`,
      // },
    });

    paymentObject.open();
  };

  const createSubscrptionOrder = async () => {
    try {
      toast.loading("Processing order");
      const { data, error } = await APIRequest(APIPath.createOrder, {
        creatorId: id,
        orderType: "subscription",
        duration: selectedPlan,
        contact: checkoutContact,
      });
      toast.remove();

      if (error) {
        return toast.error(error.message || "Unable to create order, please try again");
      }

      if (data?.status === false) {
        const backendError =
          data?.data?.error?.description ||
          data?.data?.message ||
          "Unable to create order, please check your inputs and try again";
        return toast.error(backendError);
      }

      const successMessage = data?.message || "Order placed successfully";
      toast.success(successMessage);
      initiatePayment(data);
    } catch (error) {
      console.error("createSubscrptionOrder error: ", error);
      toast.remove();
      toast.error("Something went wrong while creating the order. Please try again.");
    }
  };

  return (
    <M.DragAndDrop>
      <Modal
        footer={false}
        className="create-post-modal"
        closeIcon={false}
        width={360}
        open={show}
        onCancel={onHide}
        destroyOnClose
      >
        <div className="w-full rounded-[15px] bg-gradient-to-b from-[#146BC3] via-[#B77BC6] to-[#F48E1D] p-0.5 overflow-hidden">
          <div className="flex h-full w-full items-center justify-center bg-black rounded-[15px]  overflow-hidden p-5">
            <div className="flex-1">
              <M.Header>
                <div className="mt-6">
                  <M.UserInfoWrapper>
                    <ProtectedImage
                      as={M.UserImg}
                      url={image?.fileURL}
                      fallbackSrc={DefaultUserImg}
                      loading="eager"
                      fetchPriority="high"
                      decoding="async"
                      alt=""
                    />
                    <div>
                      <div className="flex items-center gap-2">
                        <p className="text-white capitalize text-xl mb-0">
                          {fullname}
                        </p>
                        <MdVerified className="text-white text-lg" />
                      </div>
                      <p className="text-white/60">@{username}</p>
                    </div>
                  </M.UserInfoWrapper>
                </div>
              </M.Header>

              <div className="mt-5">
                <p className="text-[15px] text-center font-medium mt-2 text-white/90">
                  Join <span className="capitalize">{fullname}'s</span> premium
                  membership
                </p>

                <ul className="flex flex-col gap-4 mt-5">
                  <li className="flex items-center gap-3">
                    <IoIosCheckmarkCircleOutline
                      className="flex-none"
                      fill="#ffffffb3"
                      size={30}
                    />
                    <span className="text-white/70 text-[1rem]">
                      Behind the scenes content.
                    </span>
                  </li>
                  <li className="flex items-center gap-3">
                    <IoIosCheckmarkCircleOutline
                      className="flex-none"
                      fill="#ffffffb3"
                      size={30}
                    />
                    <span className="text-white/70 text-[1rem]">
                      May includes surprise perks and messages from the creator.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Pricing Modal */}
              <div className="flex items-center justify-center gap-3 mt-8 flex-col sm:flex-row">
                {[1].map((num) => (
                  <div
                    key={`subscription-plans-${num}`}
                    onClick={() => setSelectedPlan(num)}
                    className={`w-full cursor-pointer rounded-[15px] sm:max-w-[150px] p-0.5 overflow-hidden ${
                      num === selectedPlan ? selectedClassName : "bg-[#3d3d3d]"
                    }`}
                  >
                    <div className="border-white bg-black rounded-[15px] pt-4 overflow-hidden text-center sm:max-w-[150px]">
                      <div className="mb-3">
                        <h3 className="text-white text-[1rem]">
                          Just ₹{getPrice(num)} for
                        </h3>
                        <h3 className="text-white text-[1rem]">
                          {num} month{num > 1 ? "s" : ""}
                        </h3>
                        <p className="text-white/70 mb-0 text-[12px] mt-4">
                          Renews monthly
                        </p>
                        <p className="text-white/70 mb-0 text-[12px]">
                          Cancel anytime 
                        </p>
                        <p className="text-white/70 mb-0 text-[12px]">
                          Prices are tax inclusive 
                        </p>
                      </div>

                      <div onClick={() => setSelectedPlan(num)}>
                        {selectedPlan === num ? (
                          <div className="w-full py-1 font-light text-[14px] text-white bg-gradient-to-r from-[#146BC3] via-[#B77BC6] to-[#F48E1D]">
                            SELECTED
                          </div>
                        ) : (
                          <div className="w-full py-1 font-light text-[14px] text-white/70">
                            Click to Select
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mb-10">
                <CommonButton
                  variant="secondary"
                  className="w-full mt-8"
                  onClick={() => createSubscrptionOrder()}
                >
                  Continue
                </CommonButton>
                <p className="text-white/60 text-center mt-5 text-[12px] mx-4">
                  By clicking on "continue" you agree to Fanxo's Payment{" "}
                  <Link to="/terms-and-conditions" className="underline-offset-2 underline">Terms, t&c</Link> and{" "}
                  <Link to="/privacy-policy" className="underline-offset-2 underline">Privacy Policy.</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </M.DragAndDrop>
  );
};

export default SubscriptionModal;




